// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill_pill__K98vi","active":"Pill_active__vAng8"};